import React from 'react';
import Icon from '../../../components/AppIcon';
import TicketCard from './TicketCard';

const TicketSection = ({ 
  title, 
  tickets, 
  emptyMessage, 
  emptyIcon = "Ticket",
  onTransfer, 
  onResendEmail, 
  onAddToWallet 
}) => {
  if (tickets?.length === 0) {
    return (
      <div className="bg-card border border-border rounded-lg p-8 text-center">
        <div className="w-16 h-16 bg-muted rounded-full flex items-center justify-center mx-auto mb-4">
          <Icon name={emptyIcon} size={32} className="text-muted-foreground" />
        </div>
        <h3 className="text-lg font-medium text-foreground mb-2">{title}</h3>
        <p className="text-muted-foreground">{emptyMessage}</p>
      </div>
    );
  }

  return (
    <div className="mb-8">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-xl font-semibold text-foreground">{title}</h2>
        <span className="text-sm text-muted-foreground bg-muted px-2 py-1 rounded-full">
          {tickets?.length} {tickets?.length === 1 ? 'ticket' : 'tickets'}
        </span>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {tickets?.map((ticket) => (
          <TicketCard
            key={ticket?.id}
            ticket={ticket}
            onTransfer={onTransfer}
            onResendEmail={onResendEmail}
            onAddToWallet={onAddToWallet}
          />
        ))}
      </div>
    </div>
  );
};

export default TicketSection;